import CardUpImg from "../../../assets/svg/nz-bg-card-up-white.svg";
import { useState } from "react";
const NZPetrolSpec = () => {
    const [activeTab, setActiveTab] = useState("DIMENSIONS");

    const specifications = {
        "DIMENSIONS": [
            { label: "Overall Length", value: "3580mm" },
            { label: "Overall Width", value: "1550mm" },
            { label: "Overall Height", value: "2020mm" },
            { label: "Wheelbase", value: "2480mm" },
            { label: "Turning Circle", value: "8600mm" },
            { label: "Ground Clearance", value: "310mm" },
            { label: "Rear Cargo Deck (Internal dimensions) (L x W x H)", value: "1600mm x 1400mm x 300mm" },
        ],
        "ENGINE": [
            { label: "Type", value: "Liquid-cooled, 3-Cylinder, 4-Stroke" },
            { label: "Bore x Stroke", value: "71mm × 84mm" },
            { label: "Displacement", value: "998cc" },
            { label: "Compression Ratio", value: "11" },
            { label: "Fuel System", value: "EFI (Petrol)" },
            { label: "Max Power", value: "69 HP / 51.1kW/4500rpm" },
            { label: "Maximum Torque", value: "93Nm/3500-4500rpm" },
            { label: "Starting", value: "Electric" },          
            { label: "Lubrication", value: "Wet Sump" },
            { label: "Transmission", value: "Manual, hydraulic clutch, Gears - 5 Forward, 1 Reverse" },
            { label: "Final Drive", value: "Shaft Driven" },
            { label: "Fuel Type", value: "91 or Greater (Petrol Unleaded)" },
            { label: "Engine Oil", value: "API SF SAE 10W/30 – 50" },
            { label: "Engine Oil Filter", value: "JX0604 (Thread ¾’’ – 16)" },
        ],
        "CAPACITIES": [
            { label: "Maximum Load (Rear Cargo Tray)", value: "550kg" },
            { label: "Fuel Tank", value: "50.0L" },
            { label: "Engine Oil ", value: "(With Filter)-3.5L" },
            { label: "Transmission Oil", value: "2.0L" },
            { label: "Front Differential", value: "0.45L" },
            { label: "Rear Differential", value: "0.85L" },
            { label: "Coolant", value: "5.0L" },
        ],
        "SUSPENSION & BRAKES": [
            { label: "Front Suspension", value: "Independent Single A-Arm with MacPherson Strut" },
            { label: "Rear Suspension", value: "Independent Dual A-Arm with Double Coil Springs" },
            { label: "Front and Rear Tyres", value: "26×11-12" },
            { label: "Front and Rear Brake", value: "Hydraulic Disc with Vacuum Booster" },
            { label: "Tyre Pressure (Front & Rear)", value: "15-30psi" },
        ],
        "STRUCTURE": [
            { label: "Chassis", value: "All Steel Ladder Design" },
            { label: "Anti-Corrosion Treatment", value: "Electrophoresis – Chassis & All Steel Panels" },
            { label: "Net Weight", value: "1140kg" },
        ],
    };

    return (
        <div className="pt-[64px] pb-[48px]">
            <div className="custom-container px-[24px] md:px-[32px] lg:px-[48px] text-start mx-auto">
                <div className="max-w-[1400px] mx-auto">
                    <h2 className="kuunari-bold text-[24px] md:text-[30px] lg:text-[40px] leading-tight text-center">
                        Specifications Petrol  Tuatara 1000EFI 
                    </h2>
                    <div className="w-full mx-auto border border-gray-300 bg-gray-50 mt-[24px] rounded-lg shadow-lg">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:flex md:w-full border-b border-gray-300 bg-gray-200">
                            {Object.keys(specifications).map((tab) => (
                                <button
                                    key={tab}
                                    className={`flex-1 text-center py-[12px] px-[12px] text-gray-700 cursor-pointer transition-all text-[14px] sm:text-[16px] md:whitespace-nowrap ${activeTab === tab ? "bg-white border-b-4 border-blue-500 text-blue-600" : ""}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="p-[12px] sm:p-[16px] md:p-[24px]">
                            {specifications[activeTab].map((item, index) => (
                                <div
                                    key={index}
                                    className="grid grid-cols-12 py-[4px] sm:py-[8px] border-b border-gray-200 last:border-none"
                                >
                                    <div className="col-span-4 sm:col-span-3 font-semibold text-gray-900 text-[12px] sm:text-[14px] md:text-[16px] text-left">
                                        {item.label}
                                    </div>
                                    <div className="col-span-4 sm:col-span-6 flex items-center justify-center">
                                        <div className="w-full border-t border-gray-400"></div>
                                    </div>
                                    <div className="col-span-4 sm:col-span-3 text-gray-800 text-[12px] sm:text-[14px] md:text-[16px] text-right">
                                        {item.value}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};
export default NZPetrolSpec;
